import { observer } from 'mobx-react';
import * as React from 'react';
import { ChoiceGroup, Radio } from 'telia-front-react';
import SelectorField from './Selector';
function RadioChoice(props) {
    const { field, helpMessage, errorMessage, callback } = props;
    const selected = field.choices.find((choice) => choice.isSelected);
    const value = selected && selected.value;
    if (field.className === 'selector') {
        return React.createElement(SelectorField, { callback: callback, field: field, helpMessage: helpMessage, errorMessage: errorMessage, inputType: 'radio' });
    }
    return (React.createElement(ChoiceGroup, { id: `field-${field.id}`, type: "radio", label: field.label, helpMessage: helpMessage, errorMessage: errorMessage, value: value, onChange: () => undefined, required: field.isRequired }, field.choices.map((choice) => (React.createElement(Radio, { key: choice.number, id: `field-${field.id}-choice-${choice.number}`, value: choice.value, checked: choice.isSelected, labelText: choice.text, onChange: (checked) => {
            choice.isSelected = checked;
            callback(field);
        }, hideLabel: field.labelHidden })))));
}
export default observer(RadioChoice);
//# sourceMappingURL=Radio.js.map